import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import App from "./App.vue";
import router from "./router";
import store from "./store/store.js";

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "ol/ol.css";
import "@fortawesome/fontawesome-free/css/all.css";

import VueGoodTablePlugin from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
Vue.use(VueGoodTablePlugin);

import { i18n } from "./i18n/index.js";

Vue.config.productionTip = false;

axios.defaults.baseURL = "/api/";
axios.interceptors.request.use(
  config => {
    const token = store.state.user.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["X-Uid"] = store.state.user.uid;

    return config;
  },
  error => Promise.reject(error)
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  function(error) {
    const originalRequest = error.config;

    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      return store.dispatch("user/refresh").then(token => {
        axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
        return axios(originalRequest);
      });
    }
  }
);

Vue.use(VueAxios, axios);

new Vue({
  store,
  router,
  i18n,
  render: h => h(App)
}).$mount("#app");

window.addEventListener(
  "resize",
  () => {
    // store.commit("view/setMobile", window.innerWidth <= 991);
    store.commit("view/setMobile", window.innerWidth <= 768);
  },
  true
);
window.dispatchEvent(new Event("resize"));
